import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "language-preview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Sprache löschen?",
    icon: "delete_forever",
    variant: "delete"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Wenn du diese Sprache löscht, gehen alle dafür hinterlegten Daten verloren. Wir werden alle Übersetzungen für diese Sprachen aus einem Chatbot löschen."),
      _hoisted_1,
      _createTextVNode("Eventuell werden dir noch einige Zeit lang Nachrichten aus dieser Sprache angezeigt, dein Chatbot wird diese Sprache aber ab sofort nicht mehr verarbeiten können. ")
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.name) + " - " + _toDisplayString(_ctx.language), 1)
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abbrechen")
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        mode: "delete",
        onClick: _ctx.deleteLanguageSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("Sprache löschen")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}